import React, { useState } from 'react';
import config from '../../../../config';
import NumberFilter from '@inovua/reactdatagrid-community/NumberFilter';
import * as Yup from 'yup';
import DateFilter from '@inovua/reactdatagrid-community/DateFilter';
import Header from '../../../components/Header/Header';
import Toolbar from '../../../components/Toolbar/Toolbar';
import Table from '../../../components/Table/Table';
import NavBar from '../../../components/NavBar/NavBar';
import { IconButton, Switch } from '@mui/material';
import { IoIosOpen } from 'react-icons/io';
import OneToManyDialog from '../../../components/OneToManyDialog';
import BoolFilter from '@inovua/reactdatagrid-community/BoolFilter';
import { useTranslation } from 'react-i18next';
import { prepareSelectUrl } from '../../../../utils';

const ProductSet = () => {
  const urls = {
    list: config.PRODUCT_SET,
    create: config.PRODUCT_SET,
    update: config.PRODUCT_SET_WITH_ID,
    delete: config.PRODUCT_SET_WITH_ID
  };
  const [products, setProducts] = useState([]);
  const resource = 'PRODUCT';
  const { t } = useTranslation();

  const columns = [
    {
      header: t('id.product'),
      name: 'productId',
      type: 'number',
      filterEditor: NumberFilter
    },
    {
      header: t('name'),
      name: 'name',
      required: true,
      type: 'string',
      validationSchema: Yup.string().max(255).required('Name is required'),
      isEditable: true,
      defaultFlex: 1
    },
    {
      header: t('description'),
      type: 'string',
      required: true,
      validationSchema: Yup.string().max(255).required('Description is required'),
      isEditable: true,
      name: 'description'
    },
    {
      header: t('type'),
      name: 'productType',
      type: 'select',
      render: ({ value }) => value && value.productTypeName,
      isEditable: false
    },
    {
      header: t('products'),
      name: 'products',
      sortable: false,
      excludeInFilter: true,
      type: 'select',
      required: true,
      options: {
        url: config.MOVIE,
        selectUrlParser: prepareSelectUrl,
        name: 'name',
        uniqueId: 'productId',
        requestField: 'productIds',
        filterField: 'productId',
        multiple: true
      },
      render: ({ value }) => (
        <IconButton
          color="primary"
          aria-label="add to shopping cart"
          onClick={() => {
            setProducts(value);
          }}>
          <IoIosOpen />
        </IconButton>
      ),
      isEditable: true
    },
    {
      header: t('is.active'),
      name: 'isActive',
      type: 'boolean',
      isEditable: true,
      filterEditor: BoolFilter,
      render: ({ value }) => <Switch disabled checked={value} />
    },
    {
      header: t('date.added'),
      name: 'dateAdded',
      type: 'date',
      filterEditor: DateFilter,
      dateFormat: 'YYYY-MM-DDTHH:mm:ss'
    },
    {
      header: t('date.modified'),
      name: 'dateModified',
      type: 'date',
      filterEditor: DateFilter,
      dateFormat: 'YYYY-MM-DDTHH:mm:ss'
    }
  ];

  return (
    <>
      <Header title={t('product.sets')} />
      <Toolbar iamResource={resource} />
      <Table
        iamResource={resource}
        uniqueId={'productId'}
        tableId={'product-set'}
        columns={columns}
        urls={urls}
      />
      <NavBar />
      <OneToManyDialog
        columns={[
          {
            header: t('id'),
            name: 'productId',
            defaultFlex: 1
          },
          {
            header: t('name'),
            name: 'name',
            defaultFlex: 1
          },
          {
            header: t('description'),
            name: 'description',
            defaultFlex: 1
          },
          {
            header: t('type'),
            name: 'productType',
            render: ({ value }) => value.productTypeName,
            defaultFlex: 1
          },
          {
            header: t('date.added'),
            name: 'dateAdded',
            defaultFlex: 1
          },
          {
            header: t('date.modified'),
            name: 'dateModified',
            defaultFlex: 1
          }
        ]}
        data={products}
        open={products.length > 0}
        handleClose={() => {
          setProducts([]);
        }}
      />
    </>
  );
};

export default ProductSet;
